module.exports = __webpack_public_path__ + "static/media/A5.7c39b496.jpg";